import axios from 'axios';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { formatCurrency } from '../../../func/Function';

interface NplItem {
  o_idx: number;
  img: string;
  collateral_address: string;
  collateral_type: string;
  appraisal_value: string;
  setting_amount: string;
  creditor_institution: string;
  up_at: string;
}

function NplCardList() {
  const [list, setList] = useState<NplItem[]>([]);

  const get_list = async () => {
    const res = await axios.get(`https://nplatform.ai/api/banner/list`);
    return res.data;
  };

  const getList = async () => {
    const result = await get_list();

    console.log('result', result.data);
    setList(result.data);
  };

  useEffect(() => {
    getList();
  }, []);

  const itemClick = () => {
    window.open(`https://nplatform.ai/`);
  };

  const formatToEokWon = (amount: string | number | null | undefined) => {
    if (amount == null) return '';
    const n =
      typeof amount === 'number'
        ? amount
        : Number(String(amount).replace(/[^\d.-]/g, ''));
    if (!Number.isFinite(n)) return '';

    const eok = Math.round(n / 100_000_000);
    return `${new Intl.NumberFormat('ko-KR').format(eok)}억원`;
  };

  return (
    <Container>
      {list &&
        list.map((item) => (
          <Card onClick={itemClick}>
            <Img
              src={item.img === null ? '/assets/images/no-image.svg' : item.img}
              alt=""
            />
            <Content>
              <Inner>
                <Type>{item.collateral_type}</Type>
                <DataWrapper>
                  <Address>{item.collateral_address}</Address>
                  <Institution>{item.creditor_institution}</Institution>
                </DataWrapper>
                <DataWrapper>
                  <PriceContainer>
                    <PriceLabel>감정 가격</PriceLabel>
                    <Price>{formatToEokWon(item.appraisal_value)}</Price>
                  </PriceContainer>
                  <PriceContainer>
                    <PriceLabel>설정 가격</PriceLabel>
                    <Price>{formatToEokWon(item.setting_amount)}</Price>
                  </PriceContainer>
                </DataWrapper>
              </Inner>
              <Date>{item.up_at && item.up_at.split('T')[0]} 등록</Date>
            </Content>
          </Card>
        ))}
    </Container>
  );
}

export default NplCardList;

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-right: 16px;
`;

const Card = styled.div`
  display: flex;
  width: 282px;
  /* height: 420px; */
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 16px;
  border: 1px solid #e1e2e4;
  background: #fff;
`;

const Img = styled.img`
  width: 282px;
  height: 180px;
  flex-shrink: 0;
  object-fit: cover;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 16px 24px 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  gap: 12px;
  align-self: stretch;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  min-height: 0;
`;

const Type = styled.div`
  color: #008aff;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const Address = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const Institution = styled.div`
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const PriceLabel = styled.div`
  color: #37383c9c;
  font-size: 13px;
  font-weight: 400;
  line-height: 145%;
  letter-spacing: -0.26px;
`;

const Price = styled.div`
  color: #222;
  font-size: 13px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.26px;
`;

const Date = styled.div`
  color: #37383c9c;
  font-size: 12px;
  font-weight: 400;
  line-height: 145%;
  letter-spacing: -0.24px;
`;
